// extracted by mini-css-extract-plugin
export default {"row":"StudentContactsBlock_row__mjBE8","editable":"StudentContactsBlock_editable__h9JjK"};